<template>
<div>
  <div>
      <el-dialog
      title="Address"
      :visible.sync="dialogVisible"
      :show-close="false"
      class="select-address-dialog"
      destroy-on-close
      :width="showH5App?'90%':'646px'">
      <div class="address-content">
        <div class="address-content-list" v-for="(e,i) in  addressList" :key='i' @click="selectAddress(e,i)"
        :class="[e.select ? 'address-border' : '']"
        >
          <div>
            {{e.name}}&nbsp;&nbsp;{{e.lastname}}<br />
            {{e.address}} <br />
            {{e.city}}, {{e.province}}, {{e.countryName}}&nbsp;&nbsp;{{e.postCode}} <br />
            {{e.areaCode}}-{{e.phone}}
          </div>
          <i class="el-icon-close address-close" @click.stop="deleteAddress(e)"></i>
        </div>
      </div>
      <div class="address-add" @click="openAddress" v-if="this.addressList.length<5">
        <div>
          <i class="el-icon-plus"></i>
          <span>Add   Address</span>
        </div>
      </div>
      <div class="address-footer">
        <span slot="footer" class="dialog-footer" center>
          <el-button type="primary" class="address-footer-button submit-button" @click="submit">Submit</el-button>
          <el-button @click="dialogVisible = false" class="address-footer-button">Cancel</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
  <div>
    <address-inner ref="addressInner" :getAddressList="getAddressList" :addressMessage="addressMessage"/>
  </div>
</div>

</template>

<script>
import { getAction, deleteAction, putAction } from '@/api/manage.js'
import addressInner from './address-inner.vue'
import publicFn from '@/utils/index'
export default {
  name: 'Address',
  components: {
    addressInner
  },
  props: {
    addressMessage: {
      type: Object
    },
    orderId: {
      type: String
    }
  },
  data() {
    return {
      dialogVisible: false,
      // addressMessage: {},
      addressList: [],
      addressSelect: ''
    }
  },
  computed: {
    showH5App() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    }
  },
  created() {
    if (this.addressMessage.userId) { this.getAddressList() }
  },
  mounted() {
  },
  methods: {
    deleteAddress: publicFn.debounce(function (data) {
      if (this.addressList.length === 1) {
        this.$message.error('Only one address, cannot be deleted')
        return false
      }
      deleteAction(`/order/address?uid=${data.uid}`).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.getAddressList()
          if (data.uid === this.addressSelect) {
            this.addressSelect = ''
          }
        } else {
          this.$message.error(res.message)
        }
      })
    }, 300),
    getAddressList() {
      this.dialogVisible = true
      this.addressList = []
      getAction(`/order/delivery/address?userId=${this.addressMessage.userId}`).then((res) => {
        res.success ? this.addressList = res.result : this.$message.error(res.message)
        let newAddress = []
        this.addressList.map((n, i) => {
          if (n.uid === this.addressMessage.addressId) {
            n.select = true
            this.addressSelect = n.uid
            this.addressList = this.addressList.splice(i, 1).concat(this.addressList)
          } else {
            n.select = false
          }
        })
        if (this.addressList.length > 5) {
          newAddress = this.addressList.splice(0, 5)
        } else {
          newAddress = this.addressList
        }
        this.addressList = newAddress
      })
    },
    openAddress() {
      this.dialogVisible = false
      this.$refs.addressInner.innerVisible = true // 打开新的
    },
    selectAddress(e, i) {
      this.addressList.map((n, key) => {
        n['select'] = false
      })
      this.addressList[i]['select'] = true
      this.addressSelect = e.uid
      // 更新视图
      this.$forceUpdate()
    },
    getName(val) {
      getAction(`/sys/gain/user/${val.userId}`).then((res) => {
        let userInfo = res.result.userInfo
        this.$refs.addressInner.form['name'] = userInfo.firstName
        this.$refs.addressInner.form['lastname'] = userInfo.lastName
      })
    },

    submit() {
      if (!this.addressSelect) {
        this.$message.warning('Please select an address')
        return
      }
      //订单处修改
      if(this.orderId){
        putAction(`/order/address/${this.orderId}/${this.addressSelect}`).then((res) => {
          console.log('设置新地址', res)
          this.dialogVisible = false
          this.$parent.loadData()
        })
      }else{
        //checkout页修改
        this.dialogVisible = false
        this.$parent.sonSelectParent(this.addressSelect)
      }

    }
  },
  watch: {
    addressMessage: function(newValue, oldValue) {
      if (newValue) {
        this.addressMessage = newValue
        this.getAddressList()
        this.$nextTick(() => {
          this.getName(newValue)
        })
      }
    },
    deep: true
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog{
  padding:25px 20px 40px 20px;
}
.address-content{
  padding-top: 10px;
  .address-content-list{
    margin-top: 20px;
    padding: 10px 30px 20px 15px;
    border: 1px solid #E1E1E1;
    border-radius: 3px;
    font-size: 14px;
    color: #5D5D5D;
    font-family: Graphik;
    font-weight: 400;
    line-height: 18px;
    position: relative;
    cursor: pointer;
    .address-close{
      position: absolute;
      top: 0px;
      right: 0px;
      font-size:16px;
      color: #8E8E8E;
      padding: 10px;
    }
  }
}
.address-footer{
  padding-top: 40px;
  display: flex;
  justify-content: center;
  .address-footer-button{
    width: 142px;
    height: 40px;
  }
}
.address-add{
  width: 100%;
  height: 50px;
  cursor: pointer;
  border: 1px solid #E1E1E1;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  color: #262B2F;
  margin-top: 20px;
}
.address-border{
  border: 1px solid #000000 !important;
}
.submit-button{
  background: #000;
  border: #000;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/address.vue